import React from 'react';

const InstantSection = () => {
  return (
    <section className="instant-section">
      <h2>L'Esperienza Baby Bolle</h2>
      <p>Un ambiente calmo, sicuro e igienico progettato specificamente per i neonati.<br />Ogni sessione è guidata da un terapista neonatale certificato.</p>

      <div className="phones-container">
        <div className="phone-text">
          Step 1<br /><strong>Galleggiamento</strong>
        </div>
        
        <div className="phone-mockup transparent">
           <div className="instant-card">
             <i className="fa-solid fa-water icon"></i>
             <h3>Idroterapia</h3>
             <p>15-20 minuti in acqua calda purificata all'ozono.</p>
           </div>
        </div>
        
        <div className="phone-text right">
          Step 2<br /><strong>Massaggio Dolce</strong>
        </div>
      </div>
    </section>
  );
};

export default InstantSection;